// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XTtR","buttons":"styles_buttons__Ci8RI"};